import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useOnClickOutside from '../../../hook/useOnClickOutSide';
import { AiOutlineCaretRight } from 'react-icons/ai';
import { VscDashboard, VscSignOut } from 'react-icons/vsc';
import { Link, useNavigate } from 'react-router-dom';
import { logOut } from '../../../services/operations/authApi';

const ProfileDropDown = () => {
    const { user } = useSelector((state) => state.profile);
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);
    const ref2 = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useOnClickOutside(ref, ref2, () => setOpen(false));
    if (!user) return null;
    return (
        <button ref={ref} className='relative' onClick={() => isOpen ? setOpen(false) : setOpen(true)}>
            <div className="flex items-center gap-x-1">
                <img
                    src={user?.image}
                    alt={user?.firstName}
                    className="aspect-square w-[30px] rounded-full object-cover"
                    loading='lazy'
                />
                {isOpen ? <AiOutlineCaretRight className="text-sm text-richblack-100 transition-all duration-300 -rotate-[90deg]" /> :
                    <AiOutlineCaretRight className="text-sm text-richblack-100  transition-all duration-300 rotate-[90deg]" />
                }
            </div>
            {isOpen &&
                <div
                    onClick={(e) => e.stopPropagation()}
                    className="absolute top-[118%] right-0 z-[1000] divide-y-[1px] divide-richblack-700 overflow-hidden rounded-md border-[1px] border-richblack-700 bg-richblack-800"
                    ref={ref2}
                >
                    <Link to="/dashboard/profile" onClick={() => setOpen(false)}>
                        <div className="flex w-full items-center gap-x-1 py-[10px] px-[12px] text-sm text-richblack-100 hover:bg-richblack-700 hover:text-richblack-25">
                            <VscDashboard className="text-lg" />
                            Dashboard
                        </div>
                    </Link>
                    <div
                        onClick={() => {
                            dispatch(logOut(navigate));
                            setOpen(false);
                        }}
                        className="flex w-full items-center gap-x-1 py-[10px] px-[12px] text-sm text-richblack-100 hover:bg-richblack-700 hover:text-richblack-25"
                    >
                        <VscSignOut className="text-lg" />
                        Log Out
                    </div>
                </div>
            }
        </button>
    );
}

export default ProfileDropDown;